<div id="panoramaParent">
  <canvas id="panoramaCanvas"></canvas>
  <!--<app-image-classifier [imageSrc]="selectedImage.latestImageUrl" (onSelectionComplete)="selectonComplete($event)"></app-image-classifier>-->
  <!--<div>
    <button class="btn btn-danger" (click)="raiseIncident()" [disabled]="selection == null">Raise Incident</button>
    <button class="btn btn-default" (click)="onClosed.emit()">Cancel</button>
  </div>-->
</div>  